<template>
  <banner :rounded="true" :showImage="false" :isWhiteBanner="true" class="AccountBlock-bgColor">
    <div
      class="
        md:gap-6
        gap-4
        grid
        justify-items-center
        text-center
        md:text-left
        grid-cols-banner
        md:items-center
      "
    >
      <img
        src="../assets/lock.svg"
        alt="Lock inside a red circle"
        width="50"
        height="50"
      />
      <div class="grid text-textPrimary font-semibold md:pr-32">
        <p class="text-errorColor text-xl">Account Blocked</p>
        <p class="text-sm">Clear payment to activate the account</p>
      </div>
      <div
        class="
          bg-red-800
          justify-between
          text-left
          items-center
          py-4
          px-7
          rounded-md
          gap-8
          flex
          w-full
          md:block
        "
      >
        <section class="flex gap-4">
            <img src="../assets/accountblock-Rupee-Icon.svg" alt="" width="35" height="35"/>
          <div class="text-left">
            <p class="text-sm text-white">Amount Payable</p>
            <p class="text font-bold text-white">
              {{ $filters.formatMoney(creditAccountInfo?.outstandingDue) }}
            </p>
          </div>
        </section>
        <section class="grid pt-2">
        <router-link
          class="btn btn--error btn--small mt-2 md:h-11"
          :to="{
            name: 'Credit Statement',
          }"
          >Clear Dues</router-link>
        </section>
      </div>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';

export default {
  name: 'AccountBlockedCard',
  components: {
    Banner,
  },
  computed: {
    ...mapGetters(['creditAccountInfo']),
  },
};
</script>
<style lang="scss" scoped>
.grid-cols-banner {
  @media only screen and (min-width: 640px) {
    grid-template-columns: auto 1fr 1fr;
  }
}
.AccountBlock-bgColor {
  background: #FFCED2;
}
</style>
